(function () {
    'use strict';

    angular
        .module('swif.openbase')
        .config(routeConfig)
        .controller('AccreditationsController', AccreditationsController)
        .controller('AccreditationController', AccreditationController);

    function routeConfig($routeProvider) {
        $routeProvider.when('/configuration/accreditations/table_view', {
            templateUrl: 'partials/openbase/accreditation_table_view.html',
            controller: 'AccreditationsController',
            reloadOnSearch: false
        });
    }

    function AccreditationsController($scope, swif) {
        // Initialize collection
        swif.collection.createOrUpdate('accreditations', 'accreditation')
            .then(function (collection) {
                $scope.accreditations = collection;
            });

        $scope.callback = function (error, data) {
            $scope.accreditations.fasterCallback(data);
        };
    }

    function AccreditationController($scope, swif) {
        // Initialize filters
        $scope.filters = {
            accreditation: {}
        };

        if ($scope.model._type == 'accreditation') {
            // Exclude current accreditation from parent selection
            swif.data.addFilter($scope.filters.accreditation, 'id', '!=', $scope.model.id);
        }
    }

})();
